module.exports = __webpack_public_path__ + "img/logo-hk.019027be.png";